module.exports = __webpack_public_path__ + "img/left-btn.ca44ff6e.svg";